// extracted by mini-css-extract-plugin
export default {"wired":"wB8BE5","title":"H1KUoX","name":"S2v2ZM"};